export default __webpack_public_path__ + "static/media/cicd.4ff70498.png";